import { gql, useQuery } from '@apollo/client';

import {
  useOrganizationPermissions_organization,
  useOrganizationPermissions_organizationVariables,
} from './graphql-types/useOrganizationPermissions_organization';

const ORGANIZATION = gql`
  query useOrganizationPermissions_organization(
    $input: SingleOrganizationInput!
  ) {
    organization(input: $input) {
      result {
        _id
        currentUserOrganizationPermission {
          canAccessOrganizationLeads
          canAccessOrganizationDirectMessages
          canSubmitOrganizationSponsorshipTierUpgradeRequest
          canCreateOrganizationSponsoredPosts
          canAttemptToCreateOrganizationSponsoredPostsWithPaywall
          canSubmitDirectMessageToOrganization
          canCreatePostInOrganization
          canManageOrganizationProfile
          canManageOrganizationSponsorship
          canAddTagsToPostInOrganization
          canManageOrganizationRoster
          canAccessDiscussionBoard
          canCaptureLeads
        }
      }
    }
  }
`;

export const useOrganizationPermissions = (
  organizationId: string | null | undefined
): {
  isLoading: boolean;
  canAccessOrganizationLeads: boolean;
  canAccessOrganizationDirectMessages: boolean;
  canSubmitOrganizationSponsorshipTierUpgradeRequest: boolean;
  canCreatePostInOrganization: boolean;
  canSubmitDirectMessageToOrganization: boolean;
  canCreateOrganizationSponsoredPosts: boolean;
  canAttemptToCreateOrganizationSponsoredPostsWithPaywall: boolean;
  canAddTagsToPostInOrganization: boolean;
  canManageOrganizationProfile: boolean;
  canManageOrganizationSponsorship: boolean;
  canManageOrganizationRoster: boolean;
  canAccessDiscussionBoard: boolean;
  canCaptureLeads: boolean;
} => {
  const { loading, data } = useQuery<
    useOrganizationPermissions_organization,
    useOrganizationPermissions_organizationVariables
  >(ORGANIZATION, {
    variables: {
      input: {
        id: organizationId,
      },
    },
  });

  const permissions =
    data?.organization?.result?.currentUserOrganizationPermission;

  return {
    isLoading: loading,
    canAccessOrganizationLeads: !!permissions?.canAccessOrganizationLeads,
    canAccessOrganizationDirectMessages:
      !!permissions?.canAccessOrganizationDirectMessages,
    canSubmitOrganizationSponsorshipTierUpgradeRequest:
      !!permissions?.canSubmitOrganizationSponsorshipTierUpgradeRequest,
    canCreatePostInOrganization: !!permissions?.canCreatePostInOrganization,
    canSubmitDirectMessageToOrganization:
      !!permissions?.canSubmitDirectMessageToOrganization,
    canCreateOrganizationSponsoredPosts:
      !!permissions?.canCreateOrganizationSponsoredPosts,
    canAttemptToCreateOrganizationSponsoredPostsWithPaywall:
      !!permissions?.canAttemptToCreateOrganizationSponsoredPostsWithPaywall,
    canAddTagsToPostInOrganization:
      !!permissions?.canAddTagsToPostInOrganization,
    canManageOrganizationProfile: !!permissions?.canManageOrganizationProfile,
    canManageOrganizationSponsorship:
      !!permissions?.canManageOrganizationSponsorship,
    canManageOrganizationRoster: !!permissions?.canManageOrganizationRoster,
    canAccessDiscussionBoard: !!permissions?.canAccessDiscussionBoard,
    canCaptureLeads: !!permissions?.canCaptureLeads,
  };
};
